<template>
  <h5 class="MenuGroupHeading">{{ title }}</h5>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.MenuGroupHeading {
  font-weight: 500;
  text-transform: uppercase;
  color: var(--menu-text-color-light);
}
</style>
